import { render, staticRenderFns } from "./CustomerMap.vue?vue&type=template&id=33d8975c&scoped=true"
import script from "./CustomerMap.vue?vue&type=script&lang=js"
export * from "./CustomerMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8975c",
  null
  
)

export default component.exports